import { jsx } from "react/jsx-runtime";
import { FeatureContextProvider } from "../hooks/useFeature/FeatureContext.js";
import { FocusModalContextProvider } from "../hooks/useFocusModal/FocusModalContextProvider.js";
import { InsightsContextProvider } from "../hooks/useInsights/InsightsContext.js";
import { LoggerContextProvider } from "../hooks/useLogger/LoggerContext.js";
import { SSOContextProvider } from "../hooks/useSSO/SSOContext.js";
import { ToastContextProvider } from "../hooks/useToasts/ToastContextProvider.js";
import { WindowSizeContextProvider } from "../hooks/useWindowSize/WindowSizeContext.js";
import "react";
import "../hooks/useFeature/FeatureManager.js";
import "../hooks/useFeature/utils.js";
import "../hooks/useFocusModal/FlashFocusModal.js";
import "../components/atoms/buttons/FlashButton/FlashButton.js";
import "../index-e71f83b5.js";
import "../_commonjsHelpers-0c53d963.js";
import "../components/constants.js";
import "../sass/sass.js";
import "../components/atoms/info/FlashBadge/FlashBadge.js";
import "../utils-65a8d69b.js";
import "../components/atoms/info/FlashSpinner/FlashSpinner.js";
import "../components/atoms/buttons/FlashButtonGeneric.js";
import "../index-5e4e4f4b.js";
import "../axios-5f69b112.js";
import "../Button-dadda608.js";
import "../hooks/useInsights/useInsights.js";
import "../utils/noOp.js";
import "../hooks/useLogger/constants.js";
import "../hooks/useLogger/useLogger.js";
import "../hooks/useLogger/types.js";
import "../hooks/useInsights/useInsightsImpression.js";
import "../index-2d889c01.js";
import "../hooks/useInsights/utils.js";
import "../utils/invokeFn.js";
import "../components/atoms/buttons/FlashButton/constants.js";
import "../components/atoms/popups/FlashPopover/FlashPopover.js";
import "../TooltipPopoverWrapper-857e7584.js";
import "react-dom";
import "../Popper-b45e70f5.js";
import "../Manager-52cb3832.js";
import "../Fade-5a502c0e.js";
import "../Transition-a28a969d.js";
import "../hooks/useOutsideClickHandler/useOutsideClickHandler.js";
import "../components/atoms/popups/FlashPopover/useFlashPopover.js";
import "../i18n/index.js";
import "../i18n/translations/en.js";
import "../i18n/translations/es.js";
import "../i18nInstance-89725fcb.js";
import "../I18nextProvider-16dc4551.js";
import "../useTranslation-cf39c293.js";
import "../utils/nextTick.js";
import "../hooks/useWindowSize/useWindowSize.js";
import "../isObject-ec23ace2.js";
import "../isSymbol-c6f5cd95.js";
import "../hooks/useFocusModal/FocusModalContext.js";
import "../hooks/useSSO/constants.js";
import "../hooks/useToasts/ToastContext.js";
import "../hooks/useToasts/ToastMaster.js";
import "../utils/constants.time.js";
import "../hooks/useToasts/utils.js";
function FlashAppContextProvider(props) {
  const { loggerProps, ssoProps, insightsProps, windowSizeProps, toastProps, featureProps, focusModal, children } = props;
  return /* @__PURE__ */ jsx(LoggerContextProvider, { ...loggerProps, children: /* @__PURE__ */ jsx(SSOContextProvider, { ...ssoProps, children: /* @__PURE__ */ jsx(InsightsContextProvider, { ...insightsProps, children: /* @__PURE__ */ jsx(WindowSizeContextProvider, { ...windowSizeProps, children: /* @__PURE__ */ jsx(ToastContextProvider, { ...toastProps, children: /* @__PURE__ */ jsx(FeatureContextProvider, { ...featureProps, children: /* @__PURE__ */ jsx(FocusModalContextProvider, { ...focusModal, children }) }) }) }) }) }) });
}
export {
  FlashAppContextProvider as default
};
//# sourceMappingURL=FlashAppContextProvider.js.map
